module.exports = __webpack_public_path__ + "img/banner.8c889a8b.jpg";